import Project from 'src/entities/Project';
import * as React from 'react';
import ProjectActionToolbarContainer from 'src/modules/project/partials/action-toolbar/ProjectActionToolbar.container';
import HtmlFormater from 'src/utils/htmlFormaterUtil';

interface Props {
  project: Project;
  invest: boolean;
  closedProject: boolean;
}

const ProjectMetricsComponent: React.StatelessComponent<Props> = (props: Props) => (
    <div className="col-sm-9">
      <div className="padding-left-30">
        <div className="gap-50"/>

        <h3>
          Métricas
        </h3>
        <div className="gap-20"/>
        <div className="row">
          <div className="col-sm-12">
            <div
              className="from-rich-editor"
              dangerouslySetInnerHTML={{__html: HtmlFormater.parseMarkDownImages(props.project.metrics)}}
            />
          </div>
        </div>
        <div className="gap-50"/>
        <ProjectActionToolbarContainer
          project={props.project}
          invest={props.invest}
          closedProject={props.closedProject}
        />
        <div className="gap-50"/>
      </div>
    </div>
  )
;

export default ProjectMetricsComponent;



// WEBPACK FOOTER //
// ./src/modules/project/partials/ProjectMetrics.component.tsx